module.exports = __webpack_public_path__ + "img/hand_image.d0bc3b71.jpeg";